import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './RDLaunchBar.scss';

const RDLaunchBar = ({
  launchBarTitle,
  logo,
  logoHeight,
  containerStyle,
  logoStyle,
  launchBarTitleStyle,
  children,
}) => (
  <div style={containerStyle}>
    <div style={logoStyle}>
      <Link className="rdlaunch-bar-logo" to="/">
        {logo && <img alt="" src={logo} height={logoHeight} />}
        {launchBarTitle && (
          <div className="rdlaunch-bar-title" style={launchBarTitleStyle}>
            {launchBarTitle}
          </div>
        )}
      </Link>
    </div>
    {children}
  </div>
);

RDLaunchBar.defaultProps = {
  logoHeight: '30px',
  containerStyle: { display: 'flex', justifyContent: 'space-between' },
  logoStyle: {},
  logo: '',
  launchBarTitle: '',
  launchBarTitleStyle: {},
};

RDLaunchBar.propTypes = {
  /** Name of the application */
  launchBarTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Logo of the application */
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Can add action items */
  children: PropTypes.element.isRequired,
  /** The height of the logo */
  logoHeight: PropTypes.string,
  /** Inline style to apply to launchbar container */
  containerStyle: PropTypes.shape({}),
  /** Inline style to apply to Logo and Title container */
  logoStyle: PropTypes.shape({}),
  /** Inline style to apply to Title */
  launchBarTitleStyle: PropTypes.shape({}),
};

export default RDLaunchBar;
